

// import React, { memo, useContext, useEffect, useState } from "react";
// import {
//   Grid,
//   Card,
//   CardHeader,
//   CardContent,
//   Typography,
//   Box,
//   useTheme,
//   useMediaQuery
// } from "@mui/material";

// import Solarpic from "../../../../../assets/img/logos/solarpic.png";
// import Load from "../../../../../assets/img/logos/load.png";
// import Grid1 from "../../../../../assets/img/logos/grid.png";
// import Watch from "../../../../../assets/img/logos/solar_dg.jpg";
// import SolarMeter from "../../../../../assets/img/logos/solar_meter.png";
// import Kusum from "../../../../../assets/img/logos/kusumDash.png";

// import { logApi, MainSumApi } from "../../../../../api/Api";

// import TempInfoStrip from '../../../../../components/dashboard/TempInfoStrip';

// import { InverterContext } from '../../../../../context/InverterContext';
// import { AppThemeContext } from '../../../../../context/AppThemeContext';
// import backgroundImage from '../../../../../assets/img/bg/chart2.png';
// import { AuthenticationContext } from '../../../../../context/AuthenticationContext'

// import SettingsIcon from '@mui/icons-material/Settings';

// import AutorenewIcon from '@mui/icons-material/Autorenew';
// import PolarAreaChart from "../../../../../components/charts/tab2Chart/PolarAreaChart";
// import SolarSvg2 from "../../../../../assets/svg/lastSolarSvg2";
// import MainSlider from "../../dashboard/dashboardTabs/tab4Content/MainSlider";
// import BottomSlider from "../../dashboard/dashboardTabs/tab4Content/BottomSlider";
// import { getDateTimeForDashboardTab1, getFromTo } from '../../../../../utils'

// import AppModal from "../../../../../components/AppModal";
// import InvverterFullSize from "../../../../../components/inverter/InvverterFullSize";

// import TopHeader from "../../../../../components/general/TopHeader";
// import SolarImageSvg from "../../../../../assets/svg/SolarImageSvg";
// import PlantEnergy from "../../dashboard/dashboardTabs/tab4Content/plantEnergy/PlantEnergy";
// import TempInfoWms from "../../../../../components/dashboard/TempInfoWms";
// import Tab4MonthlyEnergy from "../../dashboard/dashboardTabs/tab4Content/tab4MonthlyEnergy/Tab4MonthlyEnergy";
// import LastSolarSvg from "../../../../../assets/svg/LastSolarSvg";
// import LtSvg from "../../../../../assets/svg/LtSvg";
// import Leaf from "../../../../../assets/img/basic/leaf.png";
// import LtMeter from "../../../../../assets/wmsIcon/LtMeter";
// import ThermometerSvg from "../../../../../assets/wmsIcon/ThermometerSvg";
// import LtSvgImage from "../../dashboard/dashboardTabs/tab4Content/svgImagDashboard/LtSvgImage";


// export default function DashboardKusumTab1() {
//   const isMobile = useMediaQuery('(max-width:600px)');
//   const { LoggedInUserInfo } = React.useContext(AuthenticationContext)
//   const { PrimaryColor } = useContext(AppThemeContext);
//   const { spacing, palette, shape: { borderRadius } } = useTheme();
//   const { getHYBRD_Info, HYBRD_DATA_POWER_Loading, HYBRD_DATA_INFO, getPostKwhHybridForDashboard, getHYBRD_Power, HYBRD_DATA_POWER, POST_KWH_HYBRID_DATA_DASHBOARD } = useContext(InverterContext);

//   const [logData, setLogData] = useState([]);
//   const [mainData, setMainData] = useState([]);
//   const [StartDate, setStartDate] = useState(getDateTimeForDashboardTab1().LastDay)
//   const [EndDate, setEndDate] = useState(getDateTimeForDashboardTab1().Today)

//   const [OpenMix, setOpenMix] = useState(false);
//   const handleOpenMix = () => setOpenMix(true);
//   const handleCloseMix = () => setOpenMix(false);

//   const PrimaryColor2 = "#D6DCE5";
//   const PrimaryColor3 = "#F2F2F2";

//   const [credentials, setCredentials] = useState({
//     LOGIN_ID: localStorage.getItem("LoginID"),
//     LOC_CODE: localStorage.getItem("LCODE"),
//     PASS_KEY: localStorage.getItem("PASS_KEY") || "DEFAULT_PASS_KEY",
//     WEB_KEY: localStorage.getItem("WEB_KEY") || "DEFAULT_WEB_KEY",
//   });


//   const [sumCredentials, setSumCredentials] = useState({
//     LOGIN_ID: localStorage.getItem("LoginID") || "",
//     PASS_KEY: localStorage.getItem("KEY") || "xyz",
//     LCODE: localStorage.getItem("LCODE") || "",
//     DT1: StartDate,
//     DT2: EndDate,
//     TYP: "A",
//     WEB_KEY: "WEBXYZ321",
//     FID: "216HT001",
//   });



//   // this is fetching for MIDDLE data
//   const fetchLogData = async () => {
//     const res = await logApi(credentials);
//     if (res?.TOT_LIVE_KW_NEW && Array.isArray(res.TOT_LIVE_KW_NEW)) {
//       setLogData(res.TOT_LIVE_KW_NEW);
//     } else {
//       setLogData([]);
//     }
//   };

//   // useEffect(() => {
//   //     fetchLogData();
//   // }, [credentials]); // Fetch new data when credentials change


//   // this is fetching for MAIN_SUM
//   const fetchData = async () => {
//     const res = await MainSumApi(sumCredentials);
//     if (res?.KWH_MIS_MAIN_SUM && Array.isArray(res.KWH_MIS_MAIN_SUM)) {
//       setMainData(res.KWH_MIS_MAIN_SUM);
//     } else {
//       setMainData([]);
//     }
//   };



//   // useEffect(() => {
//   //   // Fetch data immediately on mount
//   //   fetchLogData();
//   //   fetchData();

//   //   // Set interval to fetch data every 30 seconds
//   //   const interval = setInterval(() => {
//   //     fetchLogData();
//   //     fetchData();
//   //   }, 60000); // 30 seconds in milliseconds

//   //   // Cleanup interval on unmount
//   //   return () => clearInterval(interval);
//   // }, [credentials, sumCredentials]); 

//   // ---------- 1) fetchLogData → refresh every 60 sec ----------
//   useEffect(() => {
//     // run on mount + when dependency changes
//     fetchLogData();

//     const interval = setInterval(() => {
//       fetchLogData();
//     }, 60000); // 60 sec

//     return () => clearInterval(interval);
//   }, [credentials, sumCredentials]);


//   // ---------- 2) fetchData → refresh every 5 min ----------
//   useEffect(() => {
//     // run on mount + when dependency changes
//     fetchData();

//     const interval = setInterval(() => {
//       fetchData();
//     }, 300000); // 5 minutes = 300000 ms

//     return () => clearInterval(interval);
//   }, [credentials, sumCredentials]);




//   const blinkingAnimationDateTime = {
//     fontWeight: "900",
//     animation: 'blinkingAnimationDateTime 2s infinite',
//     transition: 'color 0.5s ease-in-out',
//   }
//   const blinkingAnimationBatteryStatusCharging = {
//     fontWeight: "900",
//     animation: 'blinkingAnimationDateTime 2s infinite',
//     transition: 'color 0.5s ease-in-out',
//     color: 'green'
//   }
//   const blinkingAnimationBatteryStatusDischarging = {
//     fontWeight: "900",
//     animation: 'blinkingAnimationDateTime 2s infinite',
//     transition: 'color 0.5s ease-in-out',
//     color: 'red'
//   }

//   const styles = {
//     IconStyle: {
//       color: 'primary.main',
//       fontSize: '1rem'
//     }
//   }

//   // console.log("maindata",mainData,StartDate,EndDate)

//   return (
//     <>
//       <Box sx={{ minHeight: "100%", p: { xs: 0, sm: 0 } }} >
//         <Grid container spacing={1} sx={{ backgroundColor: "black", paddingBottom: ".6rem" }}>
//           {/* ---------------- LEFT SIDE ---------------- */}
//           <Grid item xs={12} lg={7}>
//             <Grid container spacing={1}>
//               {/* Left Narrow Column */}
//               <Grid item xs={12} sm={6} md={4} lg={3}>
//                 {/* Key Metrics */}
//                 <Card sx={{ mb: 1, backgroundColor: PrimaryColor2 }}>
//                   <CardHeader title="Key Metrics" sx={{ textAlign: "center" }} />
//                   <CardContent>
//                     {mainData.map((item, index) => (
//                       <Box key={index} textAlign="center">
//                         <Typography variant="body2">Solar Generation</Typography>
//                         <Typography variant="caption">Today Yield</Typography>
//                         <Typography sx={{ color: "#5CA904", fontSize: "1.4rem" }}>
//                           {item.SOLAR_DAY ?? "N/A"} kWh
//                         </Typography>
//                         <Typography variant="caption">Total Yield</Typography>
//                         <Typography sx={{ color: "#5CA904" }}>
//                           {item.SOLAR_TOTAL ?? "N/A"} kWh
//                         </Typography>
//                         <Box mt={1} pt={1} borderTop="1px solid black">
//                           <Typography variant="body2">Equivalent Income</Typography>
//                           <Typography sx={{ color: "#5CA904" }}>
//                             {item.TOT_Rev ?? "N/A"} {LoggedInUserInfo?.CURRENCY}
//                           </Typography>
//                         </Box>
//                       </Box>
//                     ))}
//                   </CardContent>
//                 </Card>

//                 {/* Active Components */}
//                 <Card sx={{ backgroundColor: PrimaryColor2, height: "12.1rem" }}>
//                   <CardHeader title="Active Components" sx={{ textAlign: "center" }} />
//                   <CardContent>
//                     <Grid container>
//                       <Grid item xs={6}>
//                         <Typography variant="body2" style={{ paddingBottom: ".4rem" }}>Inverters</Typography>
//                         <Typography variant="body2" style={{ paddingBottom: ".4rem" }}>Solar Meter</Typography>
//                         <Typography variant="body2" style={{ paddingBottom: ".4rem" }}>ABT Meter</Typography>
//                         <Typography variant="body2" style={{ paddingBottom: ".4rem" }}>Check Meter</Typography>
//                       </Grid>
//                       <Grid item xs={6}>
//                         {logData.map((item, idx) => (
//                           <Box key={idx}>
//                             <Typography variant="body2" sx={{ color: "#013b7b", paddingBottom: ".4rem" }}>
//                               {item.INV_NO}
//                             </Typography>
//                             <Typography variant="body2" sx={{ color: "#013b7b", paddingBottom: ".4rem" }}>
//                               {item.SOLAR_MTR_NO}
//                             </Typography>
//                             <Typography variant="body2" sx={{ color: "#013b7b", paddingBottom: ".4rem" }}>
//                               {item.NET_METER_NO}
//                             </Typography>
//                             <Typography variant="body2" sx={{ color: "#013b7b", paddingBottom: ".4rem" }}>
//                               {item.CHECK_METER}
//                             </Typography>

//                           </Box>
//                         ))}
//                       </Grid>
//                     </Grid>
//                   </CardContent>
//                 </Card>
//               </Grid>

//               {/* Right Wide Column */}
//               <Grid item xs={12} sm={6} md={8} lg={9}>
//                 <Grid container spacing={1}>
//                   {/* ACDB, ABT, Check Meter */}
//                   {[
//                     { title: "ACDB Meter", day: "SOLAR_DAY_MT", total: "SOLAR_TOTAL_MT" },
//                     { title: "Main ABT Meter", day: "NET_DAY_MT", total: "NET_TOTAL_MT" },
//                     { title: "Check Meter", day: "CHECK_DAY_MT", total: "CHECK_TOTAL_MT" },
//                   ].map((meter, idx) => (
//                     <Grid item xs={12} sm={6} md={4} key={idx}>
//                       <Card sx={{ backgroundColor: PrimaryColor2 }}>
//                         <CardHeader title={meter.title} sx={{ textAlign: "center", p: 1 }} />
//                         <CardContent sx={{ display: "flex", justifyContent: "space-between", p: 1 }}>
//                           <LtMeter color={PrimaryColor} height={50} width={50} />
//                           {mainData.map((item, i) => (
//                             <Box key={i} textAlign="right">
//                               <Typography>Today</Typography>
//                               <Typography sx={{ color: "#5CA904" }}>
//                                 {item[meter.day] ?? "N/A"} kWh
//                               </Typography>
//                               <Typography>Total</Typography>
//                               <Typography sx={{ color: "#5CA904" }}>
//                                 {item[meter.total] ?? "N/A"} kWh 
//                               </Typography>
//                             </Box>
//                           ))}
//                         </CardContent>
//                       </Card>
//                     </Grid>
//                   ))}

//                   {/* SVG Image */}
//                   <Grid item xs={12}>
//                     <Box sx={{ backgroundColor: PrimaryColor3, borderRadius: "8px", p: 1 }}>
//                       <LtSvgImage />
//                     </Box>
//                   </Grid>
//                 </Grid>
//               </Grid>

//               {/* Environmental Benefits */}
//               <Grid item xs={12}>
//                 <Card sx={{ backgroundColor: PrimaryColor3 }}>
//                   <CardContent>
//                     <Typography variant="h6" sx={{ color: "#5CA904" }}>
//                       Environmental Benefits
//                     </Typography>
//                     {mainData.map((item, i) => (
//                       <Grid container key={i} spacing={2}>
//                         <Grid item xs={12} sm={4}>
//                           <Typography variant="subtitle1">CO2 emission saved</Typography>
//                           <Typography sx={{ color: "#013b7b", fontWeight: "bold" }}>
//                             {item.co2_ton ?? "N/A"} CO2 emission saved
//                           </Typography>
//                         </Grid>
//                         <Grid item xs={12} sm={4}>
//                           <Typography variant="subtitle1">Equivalent Trees Planted</Typography>
//                           <Typography sx={{ color: "#013b7b", fontWeight: "bold" }}>
//                             {item.TOT_tree ?? "N/A"} Trees
//                           </Typography>
//                         </Grid>
//                         <Grid item xs={12} sm={4}>
//                           <Typography variant="subtitle1" display="flex" alignItems="center">
//                             Homes Powered
//                             <Box component="img" src={Leaf} alt="Leaf" sx={{ width: "2rem", height: "1rem", ml: 1 }} />
//                           </Typography>
//                           <Typography sx={{ color: "#013b7b", fontWeight: "bold" }}>
//                             100 Homes till date!
//                           </Typography>
//                         </Grid>
//                       </Grid>
//                     ))}
//                   </CardContent>
//                 </Card>
//               </Grid>
//             </Grid>
//           </Grid>

//           {/* ---------------- RIGHT SIDE ---------------- */}
//           <Grid item xs={12} lg={5}>
//             <Grid container spacing={1}>
//               {/* Today's Performance */}
//               <Grid item xs={12} sm={6}>
//                 {mainData.map((log, idx) => (
//                   <Card key={idx} sx={{ backgroundColor: PrimaryColor2 }}>
//                     <CardHeader title="Today's Performance" sx={{ textAlign: "center", p: 1 }} />
//                     <CardContent sx={{ p: 1 }}>
//                       <Typography>CUF: {log.CUF ?? "N/A"} | PR: {log.PR ?? "N/A"}</Typography>
//                       <Typography>Expected [kWh]: {log["EXPECT_GEN[KWH]"] ?? "N/A"}</Typography>
//                       <Typography>Peak Irradiance [W/m²]: {log.PEAK_IRRADIANCE ?? "N/A"}</Typography>
//                       <Typography>Peak Irr Time: {log.PEAK_IRR_TIME ?? "N/A"}</Typography>
//                     </CardContent>
//                   </Card>
//                 ))}
//               </Grid>

//               {/* Plant Information */}
//               <Grid item xs={12} sm={6}>
//                 {mainData.map((log, idx) => (
//                   <Card key={idx} sx={{ backgroundColor: PrimaryColor2 }}>
//                     <CardHeader title="Plant Information" sx={{ textAlign: "center", p: 1 }} />
//                     <CardContent sx={{ p: 1 }}>
//                       <Typography>Plant Information: ({credentials.LOGIN_ID})</Typography>
//                       <Typography>Name: {LoggedInUserInfo?.username}</Typography>
//                       <Typography>Capacity: {LoggedInUserInfo?.PLANT_CAPACITY}</Typography>
//                       <Typography>Address: {LoggedInUserInfo?.city}</Typography>
//                     </CardContent>
//                   </Card>
//                 ))}
//               </Grid>

//               {/* Monthly Energy Chart */}
//               <Grid item xs={12}>
//                 <Box sx={{ backgroundColor: PrimaryColor3, borderRadius: "8px", p: 1 }}>
//                   <Tab4MonthlyEnergy />
//                 </Box>
//               </Grid>
//             </Grid>
//           </Grid>
//         </Grid>
//       </Box>

//       <BottomSlider />
//     </>

//   );


// }


// 2.




import React, { memo, useContext, useEffect, useState } from "react";
import {
  Grid,
  Card,
  CardHeader,
  CardContent,
  Typography,
  Box,
  useTheme,
  useMediaQuery
} from "@mui/material";

import Solarpic from "../../../../../assets/img/logos/solarpic.png";
import Load from "../../../../../assets/img/logos/load.png";
import Grid1 from "../../../../../assets/img/logos/grid.png";
import Watch from "../../../../../assets/img/logos/solar_dg.jpg";
import SolarMeter from "../../../../../assets/img/logos/solar_meter.png";
import Kusum from "../../../../../assets/img/logos/kusumDash.png";

import { logApi, MainSumApi } from "../../../../../api/Api";

import TempInfoStrip from '../../../../../components/dashboard/TempInfoStrip';

import { InverterContext } from '../../../../../context/InverterContext';
import { AppThemeContext } from '../../../../../context/AppThemeContext';
import backgroundImage from '../../../../../assets/img/bg/chart2.png';
import { AuthenticationContext } from '../../../../../context/AuthenticationContext'

import SettingsIcon from '@mui/icons-material/Settings';

import AutorenewIcon from '@mui/icons-material/Autorenew';
import PolarAreaChart from "../../../../../components/charts/tab2Chart/PolarAreaChart";
import SolarSvg2 from "../../../../../assets/svg/lastSolarSvg2";
import MainSlider from "../../dashboard/dashboardTabs/tab4Content/MainSlider";
import BottomSlider from "../../dashboard/dashboardTabs/tab4Content/BottomSlider";
import { getDateTimeForDashboardTab1, getFromTo } from '../../../../../utils'

import AppModal from "../../../../../components/AppModal";
import InvverterFullSize from "../../../../../components/inverter/InvverterFullSize";

import TopHeader from "../../../../../components/general/TopHeader";
import SolarImageSvg from "../../../../../assets/svg/SolarImageSvg";
import PlantEnergy from "../../dashboard/dashboardTabs/tab4Content/plantEnergy/PlantEnergy";
import TempInfoWms from "../../../../../components/dashboard/TempInfoWms";
import Tab4MonthlyEnergy from "../../dashboard/dashboardTabs/tab4Content/tab4MonthlyEnergy/Tab4MonthlyEnergy";
import LastSolarSvg from "../../../../../assets/svg/LastSolarSvg";
import LtSvg from "../../../../../assets/svg/LtSvg";
import Leaf from "../../../../../assets/img/basic/leaf.png";
import LtMeter from "../../../../../assets/wmsIcon/LtMeter";
import ThermometerSvg from "../../../../../assets/wmsIcon/ThermometerSvg";
import LtSvgImage from "../../dashboard/dashboardTabs/tab4Content/svgImagDashboard/LtSvgImage";


export default function DashboardKusumTab1() {
  const isMobile = useMediaQuery('(max-width:600px)');
  const { LoggedInUserInfo } = React.useContext(AuthenticationContext)
  const { PrimaryColor } = useContext(AppThemeContext);
  const { spacing, palette, shape: { borderRadius } } = useTheme();
  const { getHYBRD_Info, HYBRD_DATA_POWER_Loading, HYBRD_DATA_INFO, getPostKwhHybridForDashboard, getHYBRD_Power, HYBRD_DATA_POWER, POST_KWH_HYBRID_DATA_DASHBOARD } = useContext(InverterContext);

  const [logData, setLogData] = useState([]);
  const [mainData, setMainData] = useState([]);
  const [StartDate, setStartDate] = useState(getDateTimeForDashboardTab1().LastDay)
  const [EndDate, setEndDate] = useState(getDateTimeForDashboardTab1().Today)

  const [OpenMix, setOpenMix] = useState(false);
  const handleOpenMix = () => setOpenMix(true);
  const handleCloseMix = () => setOpenMix(false);

  const PrimaryColor2 = "#D6DCE5";
  const PrimaryColor3 = "#F2F2F2";

  const [credentials, setCredentials] = useState({
    LOGIN_ID: localStorage.getItem("LoginID"),
    LOC_CODE: localStorage.getItem("LCODE"),
    PASS_KEY: localStorage.getItem("PASS_KEY") || "DEFAULT_PASS_KEY",
    WEB_KEY: localStorage.getItem("WEB_KEY") || "DEFAULT_WEB_KEY",
  });


  const [sumCredentials, setSumCredentials] = useState({
    LOGIN_ID: localStorage.getItem("LoginID") || "",
    PASS_KEY: localStorage.getItem("KEY") || "xyz",
    LCODE: localStorage.getItem("LCODE") || "",
    DT1: StartDate,
    DT2: EndDate,
    TYP: "A",
    WEB_KEY: "WEBXYZ321",
    FID: "216HT001",
  });



  // this is fetching for MIDDLE data
  const fetchLogData = async () => {
    const res = await logApi(credentials);
    if (res?.TOT_LIVE_KW_NEW && Array.isArray(res.TOT_LIVE_KW_NEW)) {
      setLogData(res.TOT_LIVE_KW_NEW);
    } else {
      setLogData([]);
    }
  };

  // useEffect(() => {
  //     fetchLogData();
  // }, [credentials]); // Fetch new data when credentials change


  // this is fetching for MAIN_SUM
  const fetchData = async () => {
    const res = await MainSumApi(sumCredentials);
    if (res?.KWH_MIS_MAIN_SUM && Array.isArray(res.KWH_MIS_MAIN_SUM)) {
      setMainData(res.KWH_MIS_MAIN_SUM);
    } else {
      setMainData([]);
    }
  };



  // useEffect(() => {
  //   // Fetch data immediately on mount
  //   fetchLogData();
  //   fetchData();

  //   // Set interval to fetch data every 30 seconds
  //   const interval = setInterval(() => {
  //     fetchLogData();
  //     fetchData();
  //   }, 60000); // 30 seconds in milliseconds

  //   // Cleanup interval on unmount
  //   return () => clearInterval(interval);
  // }, [credentials, sumCredentials]); 

  // ---------- 1) fetchLogData → refresh every 60 sec ----------
  useEffect(() => {
    // run on mount + when dependency changes
    fetchLogData();

    const interval = setInterval(() => {
      fetchLogData();
    }, 60000); // 60 sec

    return () => clearInterval(interval);
  }, [credentials, sumCredentials]);


  // ---------- 2) fetchData → refresh every 5 min ----------
  useEffect(() => {
    // run on mount + when dependency changes
    fetchData();

    const interval = setInterval(() => {
      fetchData();
    }, 300000); // 5 minutes = 300000 ms

    return () => clearInterval(interval);
  }, [credentials, sumCredentials]);




  const blinkingAnimationDateTime = {
    fontWeight: "900",
    animation: 'blinkingAnimationDateTime 2s infinite',
    transition: 'color 0.5s ease-in-out',
  }
  const blinkingAnimationBatteryStatusCharging = {
    fontWeight: "900",
    animation: 'blinkingAnimationDateTime 2s infinite',
    transition: 'color 0.5s ease-in-out',
    color: 'green'
  }
  const blinkingAnimationBatteryStatusDischarging = {
    fontWeight: "900",
    animation: 'blinkingAnimationDateTime 2s infinite',
    transition: 'color 0.5s ease-in-out',
    color: 'red'
  }

  const styles = {
    IconStyle: {
      color: 'primary.main',
      fontSize: '1rem'
    }
  }

  // console.log("maindata",mainData,StartDate,EndDate)

  return (
    <>
      <Box sx={{ minHeight: "100%", p: { xs: 0, sm: 0 } }} >
        <Grid container spacing={1} sx={{ backgroundColor: "black", paddingBottom: ".6rem" }}>
          {/* ---------------- LEFT SIDE ---------------- */}
          <Grid item xs={12} lg={7}>
            <Grid container spacing={1}>
              {/* Left Narrow Column */}
              <Grid item xs={12} sm={6} md={4} lg={3}>
                {/* Key Metrics */}
                <Card sx={{ mb: 1, backgroundColor: PrimaryColor2 }}>
                  <CardHeader title="Key Metrics" sx={{ textAlign: "center" }} />
                  <CardContent>
                    {mainData.map((item, index) => (
                      <Box key={index} textAlign="center">
                        <Typography variant="body2">Solar Generation</Typography>
                        <Typography variant="caption">Today Yield</Typography>
                        <Typography sx={{ color: "#5CA904", fontSize: "1.4rem" }}>
                          {item.SOLAR_DAY ?? "N/A"} kWh
                        </Typography>
                        <Typography variant="caption">Total Yield</Typography>
                        <Typography sx={{ color: "#5CA904" }}>
                          {item.SOLAR_TOTAL ?? "N/A"} kWh
                        </Typography>
                        <Box mt={1} pt={1} borderTop="1px solid black">
                          <Typography variant="body2">Equivalent Income</Typography>
                          <Typography sx={{ color: "#5CA904" }}>
                            {item.TOT_Rev ?? "N/A"} {LoggedInUserInfo?.CURRENCY}
                          </Typography>
                        </Box>
                      </Box>
                    ))}
                  </CardContent>
                </Card>

                {/* Active Components */}
                <Card sx={{ backgroundColor: PrimaryColor2, height: "12.1rem" }}>
                  <CardHeader title="Active Components" sx={{ textAlign: "center" }} />
                  <CardContent>
                    <Grid container>
                      <Grid item xs={6}>
                        <Typography variant="body2" style={{ paddingBottom: ".4rem" }}>Inverters</Typography>
                        <Typography variant="body2" style={{ paddingBottom: ".4rem" }}>Solar Meter</Typography>
                        <Typography variant="body2" style={{ paddingBottom: ".4rem" }}>ABT Meter</Typography>
                        <Typography variant="body2" style={{ paddingBottom: ".4rem" }}>Check Meter</Typography>
                      </Grid>
                      <Grid item xs={6}>
                        {logData.map((item, idx) => (
                          <Box key={idx}>
                            <Typography variant="body2" sx={{ color: "#013b7b", paddingBottom: ".4rem" }}>
                              {item.INV_NO}
                            </Typography>
                            <Typography variant="body2" sx={{ color: "#013b7b", paddingBottom: ".4rem" }}>
                              {item.SOLAR_MTR_NO}
                            </Typography>
                            <Typography variant="body2" sx={{ color: "#013b7b", paddingBottom: ".4rem" }}>
                              {item.NET_METER_NO}
                            </Typography>
                            <Typography variant="body2" sx={{ color: "#013b7b", paddingBottom: ".4rem" }}>
                              {item.CHECK_METER}
                            </Typography>

                          </Box>
                        ))}
                      </Grid>
                    </Grid>
                  </CardContent>
                </Card>
              </Grid>

              {/* Right Wide Column */}
              <Grid item xs={12} sm={6} md={8} lg={9}>
                <Grid container spacing={1}>
                  {/* ACDB, ABT, Check Meter */}
                  {[
                    {
                      title: "ACDB Meter",
                      day: "SOLAR_DAY_MT",
                      total: "SOLAR_TOTAL_MT",
                    },
                    {
                      title: "Main ABT Meter",
                      day: "NET_DAY_MT",
                      total: "NET_TOTAL_MT",
                      dayexp: "NET_DAY_MT_EXP",
                      totalexp: "NET_TOTAL_MT_EXP",
                    },
                    {
                      title: "Check Meter",
                      day: "CHECK_DAY_MT",
                      total: "CHECK_TOTAL_MT",
                      dayexp: "CHECK_DAY_MT_EXP",
                      totalexp: "CHECK_TOTAL_MT_EXP",
                    },
                  ].map((meter, idx) => (
                    <Grid item xs={12} sm={6} md={4} key={idx}>
                      <Card sx={{ backgroundColor: PrimaryColor2 }}>
                        <CardHeader
                          title={meter.title}
                          sx={{ textAlign: "center", p: 1 }}
                        />

                        <CardContent
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            p: 1,
                          }}
                        >
                          {/* LEFT SIDE ICON */}
                          <Box textAlign="center">
                            <LtMeter
                              color={PrimaryColor}
                              height={50}
                              width={50}
                            />


                          </Box>

                          {mainData.map((item, i) => (
                            <React.Fragment key={i}>
                              {/* CENTER DATA */}
                              {/* CENTER DATA */}
                              <Box textAlign="center">
                                <Typography
                                  sx={{
                                    fontWeight: "bold",
                                    fontSize: ".8rem",
                                  }}
                                >
                                  Today
                                </Typography>

                                <Typography
                                  sx={{
                                    color: "#5CA904",
                                    fontWeight: "bold",
                                    fontSize: ".95rem",
                                  }}
                                >
                                  {item[meter.day] ?? "N/A"} kWh
                                  {meter.title !== "ACDB Meter" && <>&nbsp;(I)</>}
                                </Typography>

                                <Typography
                                  sx={{
                                    fontWeight: "bold",
                                    fontSize: ".8rem",
                                    mt: 0.5,
                                  }}
                                >
                                  Total
                                </Typography>

                                <Typography
                                  sx={{
                                    color: "#5CA904",
                                    fontWeight: "bold",
                                    fontSize: ".95rem",
                                  }}
                                >
                                  {item[meter.total] ?? "N/A"} kWh
                                  {meter.title !== "ACDB Meter" && <>&nbsp;(I)</>}
                                </Typography>
                              </Box>

                              {/* RIGHT SIDE EXPORT DATA ONLY FOR ABT & CHECK */}
                              {(meter.dayexp || meter.totalexp) && (
                                <Box textAlign="right">
                                  <Typography
                                    sx={{
                                      fontWeight: "bold",
                                      fontSize: ".8rem",
                                    }}
                                  >
                                    Today
                                  </Typography>

                                  <Typography
                                    sx={{
                                      color: "#5CA904",
                                      fontWeight: "bold",
                                      fontSize: ".95rem",
                                    }}
                                  >
                                    {item[meter.dayexp] ?? "N/A"} kWh &nbsp;(E)
                                  </Typography>

                                  <Typography
                                    sx={{
                                      fontWeight: "bold",
                                      fontSize: ".8rem",
                                      mt: 0.5,
                                    }}
                                  >
                                    Total
                                  </Typography>

                                  <Typography
                                    sx={{
                                      color: "#5CA904",
                                      fontWeight: "bold",
                                      fontSize: ".95rem",
                                    }}
                                  >
                                    {item[meter.totalexp] ?? "N/A"} kWh&nbsp;(E)
                                  </Typography>
                                </Box>
                              )}
                            </React.Fragment>
                          ))}
                        </CardContent>
                      </Card>
                    </Grid>
                  ))}

                  {/* SVG Image */}
                  <Grid item xs={12}>
                    <Box
                      sx={{
                        backgroundColor: PrimaryColor3,
                        borderRadius: "8px",
                        p: 1,
                      }}
                    >
                      <LtSvgImage />
                    </Box>
                  </Grid>
                </Grid>
              </Grid>

              {/* Environmental Benefits */}
              <Grid item xs={12}>
                <Card sx={{ backgroundColor: PrimaryColor3 }}>
                  <CardContent>
                    <Typography variant="h6" sx={{ color: "#5CA904" }}>
                      Environmental Benefits
                    </Typography>
                    {mainData.map((item, i) => (
                      <Grid container key={i} spacing={2}>
                        <Grid item xs={12} sm={4}>
                          <Typography variant="subtitle1">CO2 emission saved</Typography>
                          <Typography sx={{ color: "#013b7b", fontWeight: "bold" }}>
                            {item.co2_ton ?? "N/A"} CO2 emission saved
                          </Typography>
                        </Grid>
                        <Grid item xs={12} sm={4}>
                          <Typography variant="subtitle1">Equivalent Trees Planted</Typography>
                          <Typography sx={{ color: "#013b7b", fontWeight: "bold" }}>
                            {item.TOT_tree ?? "N/A"} Trees
                          </Typography>
                        </Grid>
                        <Grid item xs={12} sm={4}>
                          <Typography variant="subtitle1" display="flex" alignItems="center">
                            Homes Powered
                            <Box component="img" src={Leaf} alt="Leaf" sx={{ width: "2rem", height: "1rem", ml: 1 }} />
                          </Typography>
                          <Typography sx={{ color: "#013b7b", fontWeight: "bold" }}>
                            100 Homes till date!
                          </Typography>
                        </Grid>
                      </Grid>
                    ))}
                  </CardContent>
                </Card>
              </Grid>
            </Grid>
          </Grid>

          {/* ---------------- RIGHT SIDE ---------------- */}
          <Grid item xs={12} lg={5}>
            <Grid container spacing={1}>
              {/* Today's Performance */}
              <Grid item xs={12} sm={6}>
                {mainData.map((log, idx) => (
                  <Card key={idx} sx={{ backgroundColor: PrimaryColor2 }}>
                    <CardHeader title="Today's Performance" sx={{ textAlign: "center", p: 1 }} />
                    <CardContent sx={{ p: 1 }}>
                      <Typography>CUF: {log.CUF ?? "N/A"} | PR: {log.PR ?? "N/A"}</Typography>
                      <Typography>Expected [kWh]: {log["EXPECT_GEN[KWH]"] ?? "N/A"}</Typography>
                      <Typography>Peak Irradiance [W/m²]: {log.PEAK_IRRADIANCE ?? "N/A"}</Typography>
                      <Typography>Peak Irr Time: {log.PEAK_IRR_TIME ?? "N/A"}</Typography>
                    </CardContent>
                  </Card>
                ))}
              </Grid>

              {/* Plant Information */}
              <Grid item xs={12} sm={6}>
                {mainData.map((log, idx) => (
                  <Card key={idx} sx={{ backgroundColor: PrimaryColor2 }}>
                    <CardHeader title="Plant Information" sx={{ textAlign: "center", p: 1 }} />
                    <CardContent sx={{ p: 1 }}>
                      <Typography>Plant Information: ({credentials.LOGIN_ID})</Typography>
                      <Typography>Name: {LoggedInUserInfo?.username}</Typography>
                      <Typography>Capacity: {LoggedInUserInfo?.PLANT_CAPACITY}</Typography>
                      <Typography>Address: {LoggedInUserInfo?.city}</Typography>
                    </CardContent>
                  </Card>
                ))}
              </Grid>

              {/* Monthly Energy Chart */}
              <Grid item xs={12}>
                <Box sx={{ backgroundColor: PrimaryColor3, borderRadius: "8px", p: 1 }}>
                  <Tab4MonthlyEnergy />
                </Box>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Box>

      <BottomSlider />
    </>

  );


}
